/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { AggregatedStatFromJSON, AggregatedStatToJSON, StatsSlotSlotIdAggregateddurationGet200ResponseFromJSON, StatsSlotSlotIdAggregateddurationGet200ResponseToJSON, StatsSlotSlotIdGet200ResponseFromJSON, StatsSlotSlotIdGet200ResponseToJSON, StatsSlotSlotIdImpressionPutRequestFromJSON, StatsSlotSlotIdImpressionPutRequestToJSON, TotalsFromJSON, TotalsToJSON, } from '../models/index';
/**
    * Converts a number to a padded string
    * @param num The number to stringify
    * @param size Number of total digits
    */
function pad(num, size) {
    let negative = num < 0;
    if (negative) {
        num *= -1;
    }
    let numString = num.toString();
    while (numString.length < size)
        numString = "0" + numString;
    return (negative ? "-" : "") + numString;
}
/**
    * Returns a date in the RFC3339 format, e.g.: 2016-01-19T15:21:32.59+02:00
    * @param dateTime
    */
export function toRFC3339(dateTime) {
    let rfcWithoutTimeoffset = `${dateTime.getFullYear()}-${pad(dateTime.getMonth() + 1, 2)}-${pad(dateTime.getDate(), 2)}T${pad(dateTime.getHours(), 2)}:${pad(dateTime.getMinutes(), 2)}:${pad(dateTime.getSeconds(), 2)}${dateTime.getMilliseconds() != 0 ? "." + pad(dateTime.getMilliseconds(), 3) : ""}`;
    let timeOffsetString;
    let to = dateTime.getTimezoneOffset() * -1;
    let toh = Math.floor(to / 60);
    let tom = to % 60;
    if (tom < 0) {
        tom *= -1;
    }
    timeOffsetString = pad(toh, 2) + ":" + pad(tom, 2);
    return rfcWithoutTimeoffset + (toh > 0 ? "+" : "") + timeOffsetString;
}
/**
 *
 */
export class StatsApi extends runtime.BaseAPI {
    /**
     * Returns the aggretaed durations (min, avg, max) for this booking, grouped by time interval
     */
    async statsBookingBookingIdAggregateddurationGetRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling statsBookingBookingIdAggregateddurationGet().');
        }
        const queryParameters = {};
        if (requestParameters['from'] != null) {
            queryParameters['from'] = toRFC3339(requestParameters['from']);
        }
        if (requestParameters['to'] != null) {
            queryParameters['to'] = toRFC3339(requestParameters['to']);
        }
        if (requestParameters['aggregation'] != null) {
            queryParameters['aggregation'] = requestParameters['aggregation'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats/booking/{bookingId}/aggregatedduration`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, AggregatedStatFromJSON));
    }
    /**
     * Returns the aggretaed durations (min, avg, max) for this booking, grouped by time interval
     */
    async statsBookingBookingIdAggregateddurationGet(requestParameters, initOverrides) {
        const response = await this.statsBookingBookingIdAggregateddurationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns the count of impressions for this booking, grouped by country code. Unknown for unknown location
     */
    async statsBookingBookingIdGeolocationGetRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling statsBookingBookingIdGeolocationGet().');
        }
        const queryParameters = {};
        if (requestParameters['from'] != null) {
            queryParameters['from'] = toRFC3339(requestParameters['from']);
        }
        if (requestParameters['to'] != null) {
            queryParameters['to'] = toRFC3339(requestParameters['to']);
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats/booking/{bookingId}/geolocation`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns the count of impressions for this booking, grouped by country code. Unknown for unknown location
     */
    async statsBookingBookingIdGeolocationGet(requestParameters, initOverrides) {
        const response = await this.statsBookingBookingIdGeolocationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns the count of impressions for this booking, grouped by time interval
     */
    async statsBookingBookingIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling statsBookingBookingIdGet().');
        }
        const queryParameters = {};
        if (requestParameters['from'] != null) {
            queryParameters['from'] = toRFC3339(requestParameters['from']);
        }
        if (requestParameters['to'] != null) {
            queryParameters['to'] = toRFC3339(requestParameters['to']);
        }
        if (requestParameters['aggregation'] != null) {
            queryParameters['aggregation'] = requestParameters['aggregation'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats/booking/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, TotalsFromJSON));
    }
    /**
     * Returns the count of impressions for this booking, grouped by time interval
     */
    async statsBookingBookingIdGet(requestParameters, initOverrides) {
        const response = await this.statsBookingBookingIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns the count of impressions for this booking, grouped by time interval
     */
    async statsBookingBookingIdImpressionsGetRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling statsBookingBookingIdImpressionsGet().');
        }
        const queryParameters = {};
        if (requestParameters['from'] != null) {
            queryParameters['from'] = toRFC3339(requestParameters['from']);
        }
        if (requestParameters['to'] != null) {
            queryParameters['to'] = toRFC3339(requestParameters['to']);
        }
        if (requestParameters['aggregation'] != null) {
            queryParameters['aggregation'] = requestParameters['aggregation'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats/booking/{bookingId}/impressions`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns the count of impressions for this booking, grouped by time interval
     */
    async statsBookingBookingIdImpressionsGet(requestParameters, initOverrides) {
        const response = await this.statsBookingBookingIdImpressionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieves the totals statistics for this booking
     */
    async statsBookingBookingIdTotalsGetRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling statsBookingBookingIdTotalsGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats/booking/{bookingId}/totals`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => TotalsFromJSON(jsonValue));
    }
    /**
     * Retrieves the totals statistics for this booking
     */
    async statsBookingBookingIdTotalsGet(requestParameters, initOverrides) {
        const response = await this.statsBookingBookingIdTotalsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns the aggretaed durations (min, avg, max) for this slot, grouped by time interval and sorted into booked and unbooked buckets
     */
    async statsSlotSlotIdAggregateddurationGetRaw(requestParameters, initOverrides) {
        if (requestParameters['slotId'] == null) {
            throw new runtime.RequiredError('slotId', 'Required parameter "slotId" was null or undefined when calling statsSlotSlotIdAggregateddurationGet().');
        }
        const queryParameters = {};
        if (requestParameters['from'] != null) {
            queryParameters['from'] = toRFC3339(requestParameters['from']);
        }
        if (requestParameters['to'] != null) {
            queryParameters['to'] = toRFC3339(requestParameters['to']);
        }
        if (requestParameters['aggregation'] != null) {
            queryParameters['aggregation'] = requestParameters['aggregation'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats/slot/{slotId}/aggregatedduration`.replace(`{${"slotId"}}`, encodeURIComponent(String(requestParameters['slotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => StatsSlotSlotIdAggregateddurationGet200ResponseFromJSON(jsonValue));
    }
    /**
     * Returns the aggretaed durations (min, avg, max) for this slot, grouped by time interval and sorted into booked and unbooked buckets
     */
    async statsSlotSlotIdAggregateddurationGet(requestParameters, initOverrides) {
        const response = await this.statsSlotSlotIdAggregateddurationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns the count of impressions for this slot, grouped by country code. Unknown for unknown location
     */
    async statsSlotSlotIdGeolocationtotalGetRaw(requestParameters, initOverrides) {
        if (requestParameters['slotId'] == null) {
            throw new runtime.RequiredError('slotId', 'Required parameter "slotId" was null or undefined when calling statsSlotSlotIdGeolocationtotalGet().');
        }
        const queryParameters = {};
        if (requestParameters['from'] != null) {
            queryParameters['from'] = toRFC3339(requestParameters['from']);
        }
        if (requestParameters['to'] != null) {
            queryParameters['to'] = toRFC3339(requestParameters['to']);
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats/slot/{slotId}/geolocationtotal`.replace(`{${"slotId"}}`, encodeURIComponent(String(requestParameters['slotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns the count of impressions for this slot, grouped by country code. Unknown for unknown location
     */
    async statsSlotSlotIdGeolocationtotalGet(requestParameters, initOverrides) {
        const response = await this.statsSlotSlotIdGeolocationtotalGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns the count of impressions for this slot, grouped by time interval
     */
    async statsSlotSlotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['slotId'] == null) {
            throw new runtime.RequiredError('slotId', 'Required parameter "slotId" was null or undefined when calling statsSlotSlotIdGet().');
        }
        const queryParameters = {};
        if (requestParameters['from'] != null) {
            queryParameters['from'] = toRFC3339(requestParameters['from']);
        }
        if (requestParameters['to'] != null) {
            queryParameters['to'] = toRFC3339(requestParameters['to']);
        }
        if (requestParameters['aggregation'] != null) {
            queryParameters['aggregation'] = requestParameters['aggregation'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stats/slot/{slotId}`.replace(`{${"slotId"}}`, encodeURIComponent(String(requestParameters['slotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => StatsSlotSlotIdGet200ResponseFromJSON(jsonValue));
    }
    /**
     * Returns the count of impressions for this slot, grouped by time interval
     */
    async statsSlotSlotIdGet(requestParameters, initOverrides) {
        const response = await this.statsSlotSlotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Repoort an impression for a booking on this slot
     */
    async statsSlotSlotIdImpressionPutRaw(requestParameters, initOverrides) {
        if (requestParameters['slotId'] == null) {
            throw new runtime.RequiredError('slotId', 'Required parameter "slotId" was null or undefined when calling statsSlotSlotIdImpressionPut().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-APP-ID"] = await this.configuration.apiKey("X-APP-ID"); // AppId authentication
        }
        const response = await this.request({
            path: `/stats/slot/{slotId}/impression`.replace(`{${"slotId"}}`, encodeURIComponent(String(requestParameters['slotId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StatsSlotSlotIdImpressionPutRequestToJSON(requestParameters['statsSlotSlotIdImpressionPutRequest']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Repoort an impression for a booking on this slot
     */
    async statsSlotSlotIdImpressionPut(requestParameters, initOverrides) {
        await this.statsSlotSlotIdImpressionPutRaw(requestParameters, initOverrides);
    }
}
